(() => {
  if(window.vertexaInstallGuide) return;
  window.vertexaInstallGuide = true;
  const bind = root => root.querySelectorAll('[data-vx-project-calculator]').forEach(form => {
    if(form.dataset.bound) return;
    form.dataset.bound = 'true';
    form.addEventListener('submit', event => {
      event.preventDefault();
      if(!form.reportValidity()) return;
      const positions = Number(form.elements.positions.value);
      const per = Number(form.elements.per_position.value);
      const extra = Number(form.elements.extra.value);
      const pack = Number(form.elements.pack.value);
      if(![positions,per,extra,pack].every(Number.isFinite) || positions < 1 || per < 1 || pack < 1) return;
      const pieces = Math.ceil(positions * per * (100 + extra) / 100);
      const packs = Math.ceil(pieces / pack);
      const result = form.querySelector('[data-vx-quantity-result]');
      const strong = document.createElement('strong');
      strong.textContent = `${pieces.toLocaleString()} pieces`;
      const detail = document.createElement('span');
      detail.textContent = `${packs.toLocaleString()} ${packs === 1 ? 'pack' : 'packs'} × ${pack.toLocaleString()} pieces = ${(packs * pack).toLocaleString()} supplied. Includes ${extra}% extra.`;
      result.replaceChildren(strong,detail);
    });
  });
  bind(document);
  document.addEventListener('shopify:section:load', event => bind(event.target));
})();
